/**
 * Logo component.
 * @module components/theme/Logo/Logo
 */

import { useSelector } from 'react-redux';
import config from '@plone/volto/registry';
import UniversalLink from '@plone/volto/components/manage/UniversalLink/UniversalLink';

import LogoSVG from './Moniviestin_logo.svg'; // Update the import
import LogoIcon from './Moniviestin_logo.svg';

/**
 * Logo component class.
 * @function Logo
 * @param {Object} intl Intl object
 * @returns {string} Markup of the component.
 */

const Logo = () => {
  const { settings } = config;
  const lang = useSelector((state) => state.intl.locale);

  return (
    <UniversalLink
      href={settings.isMultilingual ? `/${lang}` : '/'}
      title="Moniviestin"
      className="Logo-link"
    >
      <img
        className="Site-logo"
        src={LogoSVG}
        alt="Moniviestin"
        style={{ transform: 'scale(1.3)' }}
      />
      <img className="Site-logo-icon" src={LogoIcon} alt="Moniviestin" />
    </UniversalLink>
  );
};

export default Logo;
